import { motion, useAnimationControls } from "framer-motion";
import React, { PropsWithChildren, useEffect } from "react";

const marqueeVariants = (duration: number) => ({
  animate: {
    x: ["0%", "-100%"],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: "loop",
        duration: duration,
        ease: "linear",
      },
    },
  },
});

interface IMarqueeScrollProps extends PropsWithChildren {
  duration: number;
}

const MarqueeScroll = ({ duration, children }: IMarqueeScrollProps) => {
  const controls = useAnimationControls();

  useEffect(() => {
    controls.start("animate");
  }, [controls]);

  return (
    <motion.div
      className="flex w-max min-w-full items-center justify-center gap-8"
      variants={marqueeVariants(duration)}
      animate={controls}
      // onMouseEnter={() => controls.start("stop")}
      // onMouseLeave={() => controls.start("animate")}
    >
      {children}
    </motion.div>
  );
};

export default MarqueeScroll;
